<template>
	<div>
		<user-recharge
			:nickName="nickName"
		:price="Number(localprice)"
			:dialogRecharge="dialogRecharge"
			v-on:cancelRecharge="cancelRecharge"></user-recharge>
		<div class="vue-padding radius" style="padding: 15px 25px">
			<div style="width: 100%; display: flex">
				<div style="margin-right: 30px">
					<div style="padding: 10px 0; font-size: 16px">
						{{ $t("myWallet.walletbalance") }}
					</div>
					<el-row>
						<h2 style="font-size: 25px">$&nbsp;{{ userWallet | numFilter }}</h2>
						<el-button
							type="primary"
							size="mini"
							style="margin-top: 10px"
							@click="handleTopup"
							v-loading.fullscreen.lock="topupLoading"
							>{{ $t("myWallet.topup") }}</el-button
						>
						<!-- <el-button type="warning" size="mini" style="margin-left: 15px;" @click="handleWithdrawal" v-loading.fullscreen.lock="topupLoading">{{$t('myWallet.withdrawal')}}</el-button> -->
					</el-row>
				</div>
				<div style="margin-left: 30px">
					<div style="padding: 10px 0; font-size: 16px">
						{{ $t("myWallet.userUnpaidWallet") }}
					</div>
					<el-row>
						<h2 style="font-size: 25px; color: red">
							$&nbsp;{{ userUnpaidWallet | numFilter }}
						</h2>
					</el-row>
				</div>
			</div>
			<div style="padding: 10px 0; font-size: 16px; margin-top: 10px">
				{{ $t("myWallet.czdsjine") }}
			</div>
			<el-row>
				<h2 style="font-size: 20px">
					$&nbsp;{{ userFrozenWallet | numFilter }}
				</h2>
			</el-row>
			<div style="padding: 10px 0; font-size: 16px; margin-top: 10px">
				{{ $t("myWallet.czljjine") }}
			</div>
			<el-row>
				<h2 style="font-size: 20px">$&nbsp;{{ rechargeTotal | numFilter }}</h2>
			</el-row>
			<div style="padding: 10px 0; font-size: 16px; margin-top: 10px">
				{{ $t("myWallet.txdsjine") }}
			</div>
			<el-row>
				<h2 style="font-size: 20px">
					$&nbsp;{{ userWithdrawalWallet | numFilter }}
				</h2>
			</el-row>
		</div>
		<!-- 充值额度弹框 -->
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="this.$t('myWallet.qbcz')"
			:visible.sync="dialogCzEduVisible"
			width="400px"
			:close-on-press-escape="false"
			:close-on-click-modal="false"
			:show-close="false">
			<div style="display: flow-root">
				<div style="display: flow-root; line-height: 35px">
					<span style="color: red">*</span>
					<span>{{ $t("myWallet.topuptip") }}</span>
				</div>
				<el-input
					v-model="localprice"
					type="number"
					:placeholder="$t('myWallet.topuptip')"></el-input>
				<div style="color: red; margin-top: 5px">
					{{ $t("machineConfig.zuidiczje") }}
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogCzEduVisible = false">{{
					$t("common.cancel")
				}}</el-button>
				<el-button type="primary" @click="nextTopup">{{
					$t("rechargeRecord.do")
				}}</el-button>
			</span>
		</el-dialog>
		<!-- 提现额度弹框 -->
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="this.$t('myWallet.qbtx')"
			:visible.sync="dialogEduVisible"
			width="400px"
			:close-on-press-escape="false"
			:close-on-click-modal="false"
			:show-close="false">
			<div style="display: flow-root">
				<div style="display: flow-root; line-height: 35px">
					<span style="color: red">*</span>
					<span>{{ $t("myWallet.withdrawaltip") }}</span>
				</div>
				<el-input
					v-model="localprice"
					type="number"
					:placeholder="$t('myWallet.withdrawaltip')"></el-input>
				<div
					@click="handleTotal"
					style="
						width: 100%;
						line-height: 40px;
						color: #409eff;
						cursor: pointer;
					">
					{{ $t("myWallet.totalTixian") }}
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogEduVisible = false">{{
					$t("common.cancel")
				}}</el-button>
				<el-button type="primary" @click="nextWithdrawal">{{
					$t("rechargeRecord.do")
				}}</el-button>
			</span>
		</el-dialog>
		<!-- 提现信息弹框 -->
		<el-dialog
			:modal-append-to-body="true"
			:append-to-body="true"
			:title="this.$t('myWallet.withdrawalinfo')"
			:visible.sync="dialogInfoVisible"
			width="400px"
			:close-on-press-escape="false"
			:close-on-click-modal="false"
			:show-close="false"
			s>
			<div style="display: flow-root; margin-bottom: 20px">
				<div style="display: flow-root; line-height: 35px">
					<span style="color: red">*</span>
					<span>{{ $t("myWallet.skrxm") }}</span>
				</div>
				<el-input
					v-model="truename"
					:placeholder="$t('myWallet.skrxmH')"
					style="height: 35px; line-height: 35px"></el-input>
			</div>
			<div style="display: flow-root; margin-bottom: 20px">
				<div style="display: flow-root; line-height: 35px">
					<span style="color: red">*</span>
					<span>{{ $t("myWallet.skyhzh") }}</span>
				</div>
				<el-input
					type="number"
					v-model="cardnumber"
					:placeholder="$t('myWallet.skyhzhH')"
					style="height: 35px; line-height: 35px"></el-input>
			</div>
			<div style="display: flow-root; margin-bottom: 20px">
				<div style="display: flow-root; line-height: 35px">
					<span style="color: red">*</span>
					<span>{{ $t("myWallet.skyh") }}</span>
				</div>
				<!-- <el-select v-model="cardname" clearable filterable :no-data-text="$t('common.noData')" :no-match-text="$t('common.noData')" :placeholder="$t('myWallet.skyhH')" style="height: 35px; line-height: 35px;">
                    <el-option v-for="item in bankNameSet" :key="item.id" :label="item.label" :value="item.value"></el-option>
                </el-select> -->
				<el-input
					type="text"
					v-model="cardname"
					:placeholder="$t('myWallet.skyhH')"
					style="height: 35px; line-height: 35px"></el-input>
			</div>
			<div style="display: flow-root; margin-bottom: 20px">
				<div style="display: flow-root; line-height: 35px">
					<span style="color: red">*</span>
					<span>{{ $t("myWallet.dlmm") }}</span>
				</div>
				<el-input
					type="text"
					v-model="password"
					:placeholder="$t('myWallet.dlmmH')"
					style="height: 35px; line-height: 35px"></el-input>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogInfoVisible = false">{{
					$t("common.cancel")
				}}</el-button>
				<el-button type="primary" @click="nextInfo">{{
					$t("common.definite")
				}}</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import UserRecharge from "_c/mywallet/UserRecharge";
export default {
	name: "Topup",
	components: {
		UserRecharge,
	},
	data() {
		return {
			nickName: "",
			userWallet: "0.00",
			userUnpaidWallet: "0.00",
			userFrozenWallet: "0.00",
			rechargeTotal: "0.00",
			userWithdrawalWallet: "0.00",
			localprice: "",
			topupLoading: false,
			dialogRecharge: false,
			dialogCzEduVisible: false,
			dialogEduVisible: false,
			dialogInfoVisible: false,
			truename: "",
			cardnumber: "",
			cardname: "",
			password: "",
			bankNameSet: [],
		};
	},
	mounted() {
		let _self = this;
		let localuserid = _self.$store.state.uid;
		if (localuserid) {
			_self.myWallet(localuserid);
		}
		_self.getBankName();
	},
	filters: {
		numFilter(value) {
			// 截取当前数据到小数点后两位
			let realVal = parseFloat(value).toFixed(2);
			return realVal;
		},
	},
	methods: {
		// 收款银行
		getBankName() {
			let _self = this;
			_self.$api.dict("collect_bank_name").then(res => {
				if (res.code === 0) {
					_self.bankNameSet = res.data;
				}
			});
		},
		// 全部提现
		handleTotal() {
			this.localprice = this.userWallet;
		},
		// 获取我的钱包
		myWallet() {
			this.$api
				.request(this.$url.myWallet.wallet, this.$method.get)
				.then(res => {
					if (res.code == 0) {
						this.userWallet = res.data.price;
						this.userUnpaidWallet = res.data.owePrice;
						this.userFrozenWallet = res.data.freezePrice;
						this.rechargeTotal = res.data.allPrice;
						if (res.data.userWithdrawalWallet) {
							this.userWithdrawalWallet = res.data.userWithdrawalWallet;
						}
						this.nickName = res.data.userName;
					}
				});
		},
		// 充值按钮事件
		handleTopup() {
			let _self = this;
			_self.localprice = "";
			_self.dialogCzEduVisible = true;
		},
		nextTopup() {
			let _self = this;
			if (!_self.localprice) {
				_self.$message({
					message: _self.$t("myWallet.topuptip"),
					type: "warning",
				});
				return false;
			}
			if (parseFloat(_self.localprice) < 100) {
				_self.$message({
					message: _self.$t("machineConfig.zuidiczje"),
					type: "warning",
				});
				return false;
			}
			_self.dialogRecharge = true;
		},
		// 提现按钮事件
		handleWithdrawal() {
			let _self = this;
			_self.localprice = "";
			_self.dialogEduVisible = true;
		},
		nextWithdrawal() {
			let _self = this;
			if (!_self.localprice || parseFloat(_self.localprice) == 0) {
				_self.$message({
					message: _self.$t("myWallet.withdrawaltip"),
					type: "warning",
				});
				return false;
			}
			if (parseFloat(_self.localprice) > parseFloat(_self.userWallet)) {
				_self.$message({
					message: _self.$t("myWallet.WalletBuzu"),
					type: "warning",
				});
				return false;
			}
			_self.dialogInfoVisible = true;
		},
		nextInfo() {
			let _self = this;
			if (!_self.truename) {
				_self.$message({
					message: _self.$t("myWallet.skrxmH"),
					type: "warning",
				});
				return false;
			}
			if (!_self.cardnumber) {
				_self.$message({
					message: _self.$t("myWallet.skyhzhH"),
					type: "warning",
				});
				return false;
			}
			if (!_self.cardname) {
				_self.$message({
					message: _self.$t("myWallet.skyhH"),
					type: "warning",
				});
				return false;
			}
			if (!_self.password) {
				_self.$message({
					message: _self.$t("myWallet.dlmmH"),
					type: "warning",
				});
				return false;
			}
			let password = _self.$md5(_self.password);
			let obj = {
				price: _self.localprice,
				payeeName: _self.truename,
				bankAccount: _self.cardnumber,
				bankName: _self.cardname,
				password: password,
			};
			const loading = this.$loading({
				lock: true,
				text: _self.$t("myWallet.Loading"),
				spinner: "el-icon-loading",
				background: "rgba(0, 0, 0, 0.7)",
			});
			_self.$api
				.request(_self.$url.myWallet.wInsert, _self.$method.post, obj)
				.then(res => {
					loading.close();
					if (res.code == 0) {
						_self.$message({
							message: _self.$t("myWallet.txshs"),
							type: "success",
						});
						_self.localprice = "";
						_self.truename = "";
						_self.cardnumber = "";
						_self.cardname = "";
						_self.password = "";
						_self.dialogEduVisible = false;
						_self.dialogInfoVisible = false;
						window.location.reload();
					} else {
						_self.$message({
							message: res.msg,
							type: "warning",
						});
						return false;
					}
				});
		},
		// 取消充值
		cancelRecharge(dialog, state) {
			this.dialogRecharge = dialog;
			this.dialogCzEduVisible = false;
			if (state) {
				let localuserid = sessionStorage.getItem("localuserid");
				this.myWallet(localuserid);
			}
		},
	},
};
</script>

<style lang="scss">
.el-dialog__body {
	height: auto !important;
	padding: 10px 20px;
}
</style>
